import {useEffect, useRef} from 'react';
import {isbot} from 'isbot';
import {getChatSessionId} from '@scripttag/helpers/sessionHelpers';

const BROWSED_PAGE_VIEW_DELAY = 3000;

/**
 * Hook to track browsed pages for chat functionality
 * Only tracks after user has interacted with the page
 */
export default function useBrowsedPageTracking({settings, postData, hasInteracted}) {
  const documentTitle = useRef(document.title);

  useEffect(() => {
    if (!settings.isLiveChat || isbot(navigator.userAgent) || !hasInteracted) return;

    const sessionId = getChatSessionId();
    if (!sessionId) return;

    const browsedPageTimeout = setTimeout(() => {
      postData('/browsedPages/view', {
        sessionId,
        data: {title: documentTitle.current, path: window.location.pathname}
      });
    }, BROWSED_PAGE_VIEW_DELAY);

    return () => clearTimeout(browsedPageTimeout);
  }, [hasInteracted]);

  return {documentTitle};
}
